import { render, staticRenderFns } from "./y_choose_goods.vue?vue&type=template&id=3c7ace61&scoped=true"
import script from "./y_choose_goods.vue?vue&type=script&lang=js"
export * from "./y_choose_goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ace61",
  null
  
)

export default component.exports